import { elapsed, timeStampNow } from '@datadog/browser-core';
import { serializeNodeWithId } from './serializeNode';
import { updateSerializationStats } from './serializationStats';
export function serializeDocument(document, configuration, serializationContext) {
    const serializationStart = timeStampNow();
    const serializedNode = serializeNodeWithId(document, {
        serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration,
    });
    updateSerializationStats(serializationContext.serializationStats, 'serializationDuration', elapsed(serializationStart, timeStampNow()));
    // We are sure that Documents are never ignored, so this function never returns null
    return serializedNode;
}
//# sourceMappingURL=serializeDocument.js.map